import { render, staticRenderFns } from "./CompetenceFilter.vue?vue&type=template&id=45b3701b&scoped=true"
import script from "./CompetenceFilter.vue?vue&type=script&lang=js"
export * from "./CompetenceFilter.vue?vue&type=script&lang=js"
import style0 from "./CompetenceFilter.vue?vue&type=style&index=0&id=45b3701b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b3701b",
  null
  
)

export default component.exports